import React, {useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {maintenanceVaild} from "../../../components/commonmethod/CommonMethod";
import Th_title from "../../../components/Th_title";
import {SelectComboBoxForCreate} from "../../../components/select/SelectComboBoxForCreate";
import {saveWork} from "../../../api/maintenance/WorkService";
import {inspectionRequestCode, useSla} from "../inspection/InspectionCreate";
import {CodeSpecNum, ContentCategory} from "../../../constant/CodeSpecNum";
import {apiLoading} from "../../../redux/slice/apiSlice";
import {useDispatch, useSelector} from "react-redux";
import {onCreateClickListener} from "../../../components/commonmethod/simmsDrawerMethod";
import SimmsInputSearch from "../../../components/input/SimmsInputSearch";
import SimmsDrawerSearch from "../../../components/drawer/simms/SimmsDrawerSearch";
import {SimmsRadio} from "../../../components/input/SimmsRadio";
import {inputOnChange} from "../../../components/commonmethod/simmsInputMethod";
import Selector from "../../../components/selector/Selector";
import SearchSelector from "../../../components/searchSelector/SearchSelector";
import UserSelectionField from "../../../components/selection/UserSelectionField";
import SimmsInput from "../../../components/input/SimmsInput";
import SimmsDatePicker from "../../../components/datepicker/SimmsDatePicker";
import {dateOnChange} from "../../../components/commonmethod/simmsDateMethod";
import dayjs from "dayjs";
import SimmsTextArea from "../../../components/input/SimmsTextArea";
import {
    ContentDetailThreeColLayout,
    DetailFilePanel,
    DetailKvReadOnly,
    DetailKvTable,
    DetailFormPageShell,
    DetailListPage,
    DetailPanel,
    DetailSummaryButton,
} from "../../../components/detailLayout";
import "../../../components/detailLayout/detailListLayout.css";

export const connectedInfoRadio = [
    {value: ContentCategory.NONE, text: "없음"},
    {value: ContentCategory.SERVICE_REQUEST, text: "서비스접수"},
    {value: ContentCategory.INCIDENT, text: "장애"},
    {value: ContentCategory.INSPECTION, text: "점검"},
];

export const workAcceptCode = [
    {id: "고객 Call", name: "고객 Call"},
    {id: "운영 Call", name: "운영 Call"},
    {id: "현업 Call", name: "현업 Call"},
    {id: "모니터링", name: "모니터링"},
    {id: "기타", name: "기타"}
];

function WorkCreate() {
    const dispatch = useDispatch();
    const user = useSelector(state => state.auth.user);
    const currentDate = new Date();
    const [work, setWork] = useState({
        useSla: true, connectedInfo: ContentCategory.NONE, requester: user, inspector: user
    });
    const [assets, setAssets] = useState([]);
    const [docs, setDocs] = useState([]);
    const [handler, setHandler] = useState([]);
    const location = useLocation();
    const navigate = useNavigate();
    const requireds = ["title", "requester", "workCode", "workStartDate", "workEndDate", "title", "useSla", "inspector"];

    const create = async () => {
        if (assets.length === 0) {
            alert("자산을 선택해주세요");
            return false;
        }

        if (!maintenanceVaild(handler, work, requireds)) return;

        if (work.connectedInfo !== ContentCategory.NONE && !work.connectedId) {
            alert("연계정보를 선택해주세요");
            return;
        }

        dispatch(apiLoading(true));

        const docFile = [];
        docs.forEach(each => docFile.push(each.object));

        const data = {
            ...work,
            workCode: {id: work.workCode.id},
            inspector: {id: work.inspector.id},
            requester: {id: work.requester.id},
            location: work.location ? {id: work.location.id} : null,
        };

        await saveWork(data, assets, handler, docFile).then(response => {
            if (response.status === 200) {
                alert("등록되었습니다.");
                const newId = response.data?.id;
                if (newId) {
                    navigate(`/maintenance/work/${newId}`, {state: {id: newId}});
                } else {
                    navigate("/maintenance/work", {state: {test: location.state}});
                }
            }
        }).finally(() => dispatch(apiLoading(false)));
    };

    const onChangeConnectedInfo = (each) => {
        setWork((prev) => ({
            ...prev,
            connectedId: each.id,
            connectedObject: each
        }));
    };

    const handleRadioInfo = (each) => {
        setWork((prev) => {
            const {connectedObject, connectedId, ...rest} = prev;
            return {
                ...rest,
                connectedInfo: each,
            };
        });
    };

    const requestInfoPanel = (
        <DetailPanel title="작업요청정보">
            <DetailKvTable>
                <tbody>
                <tr className="asset-detail-kv-row--auto">
                    <Th_title title="자산목록" colspan={3} className="fieldset-td relative align-top" required auth>
                        <UserSelectionField
                            layout="inline"
                            data={assets}
                            countUnit="개"
                            chipEntity="asset"
                            listModalTitle="자산목록"
                            onRemove={(v) => setAssets((prev) => prev.filter((asset) => asset.id !== v.id))}
                        >
                            <SearchSelector
                                auth
                                multiSelect
                                variant="compact"
                                entity="maintenance-assets"
                                uniqueKey="assets"
                                data={assets}
                                onChange={(v) => {
                                    if (v?.__multiFlat) setAssets(v.__multiFlat);
                                }}
                            >
                                <SimmsInputSearch type="TEXT"/>
                                <SimmsDrawerSearch showLabel title="자산그룹" entity="code" target="group" parentKey={CodeSpecNum.AssetGroupCode} uniqueKey="group" recursive/>
                                <SimmsDrawerSearch showLabel title="업무그룹" entity="code" target="task" parentKey={CodeSpecNum.TaskGroupCode} uniqueKey="task" recursive/>
                                <SimmsDrawerSearch showLabel title="자산위치" entity="code" target="location" parentKey={CodeSpecNum.AssetLocation} uniqueKey="location" recursive/>
                                <SimmsDrawerSearch showLabel title="SLA 그룹" entity="code" target="slaGroup" parentKey={CodeSpecNum.SlaGroupCode} uniqueKey="slaGroup" recursive/>
                                <SimmsDrawerSearch showLabel title="운영담당자" entity="userAccount" target="operator"/>
                                <SimmsDrawerSearch showLabel title="자산사용자" entity="userAccount" target="handler"/>
                            </SearchSelector>
                        </UserSelectionField>
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="작업연계정보" colspan={3} className="fieldset-td relative align-top" auth>
                        <SimmsRadio
                            options={connectedInfoRadio}
                            onChange={(v) => handleRadioInfo(v)}
                            data={work.connectedInfo}
                        />
                    </Th_title>
                </tr>
                {work.connectedInfo !== ContentCategory.NONE && (
                    <tr>
                        <Th_title title="연계정보 선택" colspan={3} className="fieldset-td" auth>
                            <Selector
                                onChange={(v) => onChangeConnectedInfo(v)}
                                data={work.connectedObject}
                                entity={work.connectedInfo}
                                uniqueKey={work.connectedInfo}
                            >
                                <SimmsInputSearch type="TEXT" placeHolder="연계정보명"/>
                            </Selector>
                        </Th_title>
                    </tr>
                )}
                {work.connectedObject && (
                    <tr>
                        <Th_title title="연계정보" colspan={3} className="fieldset-td relative align-top" auth>
                            <div>제목 : {work.connectedObject.title}</div>
                            <div>등록일 : {work.connectedObject.createdAt}</div>
                            <div>수정일 : {work.connectedObject.updatedAt}</div>
                        </Th_title>
                    </tr>
                )}
                <tr>
                    <DetailKvReadOnly label="등록일시" value={currentDate.toISOString()} type="date"/>
                    <DetailKvReadOnly label="등록자" value={user.name}/>
                </tr>
                <tr>
                    <DetailKvReadOnly label="수정일시" value=""/>
                    <DetailKvReadOnly label="수정자" value=""/>
                </tr>
                <tr>
                    <Th_title title="요청자" colspan={3} className="fieldset-td" required auth>
                        <Selector
                            onChange={(v) => onCreateClickListener(setWork, "requester", work.requester, v)}
                            data={work.requester}
                            entity="userAccount"
                            uniqueKey="requester"
                        >
                            <SimmsInputSearch type="TEXT" placeHolder="사용자명"/>
                            <SimmsDrawerSearch showLabel title="부서" entity="department" target="department" recursive/>
                            <SimmsDrawerSearch showLabel title="업체" entity="company" target="company"/>
                        </Selector>
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="작업종류" colspan={1} className="fieldset-td" required auth>
                        <Selector
                            onChange={(v) => onCreateClickListener(setWork, "workCode", work.workCode, v)}
                            data={work.workCode}
                            entity="code"
                            parentKey={CodeSpecNum.WorkRequestCode}
                            recursive
                        />
                    </Th_title>
                    <Th_title title="요청방식" colspan={1} className="fieldset-td" auth>
                        <SelectComboBoxForCreate
                            target="workRequest"
                            options={inspectionRequestCode}
                            data={{data: work, fnc: setWork}}
                            defaultValue={work.workRequest}
                        />
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="작업인지" colspan={1} className="fieldset-td" auth>
                        <div className="flex items-center gap-1 w-full min-w-0">
                            <SelectComboBoxForCreate
                                target="workAcceptCode"
                                options={workAcceptCode}
                                data={{data: work, fnc: setWork}}
                                defaultValue={work.workAcceptCode}
                            />
                            <SimmsInput
                                onChange={(v) => inputOnChange(setWork, "workAcceptText", v, false)}
                                data={work.workAcceptText}
                                style={{flex: "1 1 auto", minWidth: 0, width: "auto"}}
                            />
                        </div>
                    </Th_title>
                    <Th_title title="작업위치" colspan={1} className="fieldset-td fieldset-td-input" auth>
                        <Selector
                            onChange={(v) => onCreateClickListener(setWork, "location", work.location, v)}
                            data={work.location}
                            entity="code"
                            parentKey={CodeSpecNum.AssetLocation}
                            recursive
                        />
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="작업기간" colspan={3} className="fieldset-td fieldset-td-input" required>
                        <div className="web-flex asset-detail-date-range">
                            <SimmsDatePicker
                                onChange={(v) => dateOnChange(setWork, "workStartDate", v, true)}
                                data={work.workStartDate}
                                constraint={{lessThan: work.workEndDate && dayjs(work.workEndDate), required: true}}
                                auth
                            />
                            <span className="asset-detail-date-range-sep">~</span>
                            <SimmsDatePicker
                                onChange={(v) => dateOnChange(setWork, "workEndDate", v, true)}
                                data={work.workEndDate}
                                constraint={{largerThan: work.workStartDate && dayjs(work.workStartDate), required: true}}
                                auth
                            />
                        </div>
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="작업 제목" colspan={3} className="fieldset-td" required auth>
                        <SimmsInput onChange={(v) => inputOnChange(setWork, "title", v, true)} data={work.title}/>
                    </Th_title>
                </tr>
                <tr className="asset-detail-kv-row--auto">
                    <Th_title title="작업내용" colspan={3} className="fieldset-td" auth>
                        <SimmsTextArea onChange={(v) => inputOnChange(setWork, "workContent", v, false)} data={work.workContent} style={{width: "100%", minHeight: "80px"}}/>
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="SLA 사용여부" colspan={3} className="fieldset-td" required auth>
                        <SimmsRadio
                            options={useSla}
                            onChange={(v) => inputOnChange(setWork, "useSla", v, true)}
                            data={work.useSla}
                        />
                    </Th_title>
                </tr>
                <tr className="asset-detail-kv-row--auto">
                    <Th_title title="비고" colspan={3} className="fieldset-td" auth>
                        <SimmsTextArea onChange={(v) => inputOnChange(setWork, "etc", v, false)} data={work.etc} style={{width: "100%", minHeight: "80px"}}/>
                    </Th_title>
                </tr>
                </tbody>
            </DetailKvTable>
        </DetailPanel>
    );

    const statusPanel = (
        <DetailPanel title="작업 요청 진행상태">
            <DetailKvTable>
                <tbody>
                <tr className="asset-detail-kv-row--auto">
                    <Th_title title="담당자" colspan={3} className="fieldset-td fieldset-td-input relative align-top" required auth>
                        <UserSelectionField
                            layout="inline"
                            data={handler}
                            onRemove={(v) => setHandler((prev) => prev.filter((h) => h.id !== v.id))}
                        >
                            <SearchSelector
                                auth
                                multiSelect
                                variant="compact"
                                entity="userAccount"
                                uniqueKey="handler"
                                data={handler}
                                onChange={(v) => {
                                    if (v?.__multiFlat) setHandler(v.__multiFlat);
                                }}
                            >
                                <SimmsInputSearch type="TEXT" placeHolder="사용자명"/>
                                <SimmsDrawerSearch showLabel title="부서" entity="department" target="department" recursive/>
                                <SimmsDrawerSearch showLabel title="업체" entity="company" target="company"/>
                            </SearchSelector>
                        </UserSelectionField>
                    </Th_title>
                </tr>
                <tr>
                    <Th_title title="검수자" colspan={3} className="fieldset-td" required auth>
                        <Selector
                            onChange={(v) => onCreateClickListener(setWork, "inspector", work.inspector, v)}
                            data={work.inspector}
                            entity="userAccount"
                            uniqueKey="inspector"
                        >
                            <SimmsInputSearch type="TEXT" placeHolder="사용자명"/>
                            <SimmsDrawerSearch showLabel title="부서" entity="department" target="department" recursive/>
                            <SimmsDrawerSearch showLabel title="업체" entity="company" target="company"/>
                        </Selector>
                    </Th_title>
                </tr>
                </tbody>
            </DetailKvTable>
        </DetailPanel>
    );

    const filePanel = (
        <DetailFilePanel
            title="첨부"
            isEditing
            pendingFiles={{files: docs, setFiles: setDocs}}
            pendingInputId="work_create_doc"
        />
    );

    return (
        <DetailFormPageShell
            className="common-container container-height-full border-l-gray create-page detail-list-layout asset-detail-list-layout"
            title="작업 등록"
            meta="신규 작업 정보를 입력하세요"
            actions={
                <>
                    <DetailSummaryButton muted onClick={() => navigate("/maintenance/work")}>
                        취소
                    </DetailSummaryButton>
                    <DetailSummaryButton
                        onClick={() => {
                            if (window.confirm("등록 하시겠습니까?")) {
                                create();
                            }
                        }}
                    >
                        등록
                    </DetailSummaryButton>
                </>
            }
        >
            <DetailListPage isEditing className="flex min-h-0 flex-1 flex-col">
                <div className="container-height-body asset-detail-body detail-list-body flex min-h-0 flex-1 flex-col overflow-hidden">
                    <ContentDetailThreeColLayout
                        primary={requestInfoPanel}
                        secondary={statusPanel}
                        aside={filePanel}
                    />
                </div>
            </DetailListPage>
        </DetailFormPageShell>
    );
}

export {WorkCreate};
